"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var favoriteNodeParser = require("../helpers/favoriteNodeParser");
var favoritesBitFlagsActions = require("../helpers/favoritesBitFlagsActions");
var loadFavorites_1 = require("../loadFavorites");
var userConfigurationDictionaryEntry_1 = require("owa-service/lib/factory/userConfigurationDictionaryEntry");
var userConfigurationDictionaryObject_1 = require("owa-service/lib/factory/userConfigurationDictionaryObject");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var updateUserConfiguration_1 = require("owa-session-store/lib/services/updateUserConfiguration");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Update local and server userOptions.FavoriteNodes and userOptions.FavoritesBitFlags
 * @param favoritesStore the favorites store
 * @param userOptions the user options
 */
function updateFavoritesAndMarkMigrationComplete(favoritesStore, userOptions) {
    var newFavoritesNodesRaw = favoriteNodeParser.serialize(favoritesStore.orderedFavoritesNodeIds, favoritesStore.favoritesFolderNodes, favoritesStore.favoritesPersonaNodes, favoritesStore.favoriteSearches, favoritesStore.favoriteCategories);
    // Update the local user configuration store
    userOptions.FavoriteNodes = newFavoritesNodesRaw;
    favoritesBitFlagsActions.setBit(true /* value*/, 2 /* FirstRunFavoritesMigration */);
    // Send out request to update both UserOptions.FavoriteNodes and FavoritesBitFlags
    updateUserConfiguration_1.default('OWA.UserOptions', [
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['FavoriteNodes'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'StringArray',
                Value: newFavoritesNodesRaw,
            }),
        }),
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['FavoritesBitFlags'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'Integer32',
                Value: ["" + userOptions.FavoritesBitFlags],
            }),
        }),
    ]);
}
/**
 * Migrate single favorite folder
 * @param folderId the folder to be migrated
 */
function tryMigrateSingleFavoriteFolder(folderId) {
    var favoriteFolderNode = {
        id: folderId,
        type: 0 /* Folder */,
    };
    loadFavorites_1.tryAddSingleFavoriteFolderToStore(favoriteFolderNode);
}
/**
 * Migrate the favorites for the first run experience
 * @param state the MigrateFavoritesState
 */
exports.default = legacy_1.action('migrateFavorites')(legacy_1.select({
    favoritesStore: function () { return store_1.default; },
})(function migrateFavorites(state) {
    var favoritesStore = state.favoritesStore;
    // 1. Automatically populate default folders it they don't exist in favorites
    var defaultFavoriteFolderIds = [
        folderNameToId_1.default('inbox'),
        folderNameToId_1.default('drafts'),
        folderNameToId_1.default('archive'),
    ];
    defaultFavoriteFolderIds.forEach(function (folderId) { return tryMigrateSingleFavoriteFolder(folderId); });
    // 2. Load existing UserOptions.FavoriteNodes to store if there is any
    loadFavorites_1.loadFavoriteNodesToStore(favoritesStore);
    // 3. Migrate de-duped UserOptions.FavoriteFolders(used by JsMVVM) to FavoriteNodes(used by React), if there is any
    var userOptions = getUserConfiguration_1.default().UserOptions;
    if (userOptions.FavoriteFolders) {
        userOptions.FavoriteFolders.forEach(function (folderId) {
            return tryMigrateSingleFavoriteFolder(folderId);
        });
    }
    // 4. Submit the service call to update UserOptions on the client and server
    updateFavoritesAndMarkMigrationComplete(favoritesStore, userOptions);
}));
//# sourceMappingURL=migrateFavorites.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/firstRun/migrateFavorites.js
// module id = 4645
// module chunks = 14